import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Select,
  MenuItem,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useHistory, useLocation } from "react-router-dom";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import Admin from "../../../components/auth/Admin";
import Role from "../../../actions/role";
import Layout from "../../../components/layout/Layout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { isAuth } from "../../../actions/auth";

const headCells = [
  { id: "fullName", label: "Full Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone Number" },
  { id: "username", label: "UserName" },
];

const RoleDetailPage = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllRole } = Role();
  const [staff, setStaffs] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  let location = useLocation();

  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getAllStaffs();
  }, [reload]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllStaffs = () => {
    setValues({ ...values, loading: true });
    viewAllRole(value).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.role) {
        setValues({ ...values, loading: false });
        if (isAuth().role === "admin" && data.role.name === "Admin") {
          const newStaffRole = {
            id: "new-staff-role-id",
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            roleid: "2052bf05-cf71-457b-925c-5c5284957392",
            staffRole: "new-staff-role-id",
            staff: isAuth(),
          };
          data.role?.staffRoles.push(newStaffRole);
        }
        const staffArray = data.role.staffRoles
          .map((staffRole) => staffRole.staff)
          .filter((staff) => staff);
        setStaffs(staffArray);
      }
    });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(staff, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["fullName", "email"];
        if (target.value === "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push("/roles");
              }}
            ></ArrowBackIcon>{" "}
            <span style={{ marginLeft: "6px" }}>Staffs</span>
          </Typography>
          <div
            className="search-header-container"
            style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
          >
            <div className="search-header-flex">
              <div className="search-container">
                <AiOutlineSearch className="search_icon" />
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Staff"
                  className="search-input"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          <Grid container>
            <Grid item xs={12}>
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.fullName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.username}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>
          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default RoleDetailPage;
